var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#8EBD21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0475 11H12.9525C12.4239 11 12 11.4306 12 11.9677V36.911C12 37.4435 12.4239 37.8788 12.9525 37.8788H20.1353L25.8824 43.7176C26.2562 44.0972 26.8578 44.0972 27.2269 43.7176L32.9741 37.8788H40.0475C40.5716 37.8788 41 37.4482 41 36.911V11.9677C41 11.4352 40.5761 11 40.0475 11Z",
    fill: "#2573AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 33,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtwork);
export default __webpack_public_path__ + "static/media/artwork.fe4350f0b5f0454537145d267a70c364.svg";
export { ForwardRef as ReactComponent };